export default "__VITE_ASSET__f8b38863__"